import PageLoadedQueue from "../../../../../../../Solutions.Neos.Site/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue";

export function shareProfilePage() {
    const shareButtons = document.querySelectorAll(".profile-page-share-for-social") as NodeListOf<HTMLButtonElement>;
    if (!shareButtons.length === 0) {
        return;
    }

    shareButtons.forEach((shareButton) => {
        const shareData = {
            title: "Solutions - Finde deinen Experten!",
            text: "Hey, sieh dir diesen Experten an den ich gefunden habe!",
            url: shareButton.dataset.shareUri ?? 'https://' + window.location.host + window.location.pathname,
        };

        shareButton.addEventListener("click", async () => {
            try {
                await navigator.share(shareData);
            } catch (err) {
                console.error(err);
            }
        });
    });
}

export function videos() {
    const video1 = document.getElementById("profile-page-video1") as HTMLVideoElement;
    const video2 = document.getElementById("profile-page-video2") as HTMLVideoElement;
    const video3 = document.getElementById("profile-page-video3") as HTMLVideoElement;

    if (!video1 || !video2 || !video3) {
        return;
    }

    const playVideo1 = () => {
        video1.play();
    }

    const playVideo2 = () => {
        video2.play();
    }

    const playVideo3 = () => {
        video3.play();
    }

    const hoverVideo1 = () => {
        video1.play();
        video2.pause();
        video3.pause();
    }

    const hoverVideo2 = () => {
        video1.pause();
        video2.play();
        video3.pause();
    }

    const hoverVideo3 = () => {
        video1.pause();
        video2.pause();
        video3.play();
    }

    const outVideo1 = () => {
        video1.pause();
    }
    const outVideo2 = () => {
        video2.pause();
    }
    const outVideo3 = () => {
        video3.pause();
    }

    video1.play();

    const videoContainerEventListener = () => {
        video1.addEventListener("ended", playVideo2);
        video2.addEventListener("ended", playVideo3);
        video3.addEventListener("ended", playVideo1);

        if (video1.paused && video2.paused && video3.paused) {
            video1.play();
            video2.pause();
            video3.pause();
        }
    }

    const videoContainer = document.querySelector('.profile-video-container');
    if (videoContainer) {
        videoContainer.addEventListener('mouseleave', videoContainerEventListener);
    }

    video1.addEventListener("ended", playVideo2);
    video2.addEventListener("ended", playVideo3);
    video3.addEventListener("ended", playVideo1);

    video1.addEventListener('mouseenter', hoverVideo1)
    video2.addEventListener('mouseenter', hoverVideo2)
    video3.addEventListener('mouseenter', hoverVideo3)

    video1.addEventListener('mouseout', outVideo1)
    video2.addEventListener('mouseout', outVideo2)
    video3.addEventListener('mouseout', outVideo3)

    video1.addEventListener("click", () => {
        video1.removeEventListener("ended", playVideo2);
        video2.removeEventListener("ended", playVideo3);
        video3.removeEventListener("ended", playVideo1);
        videoContainer.removeEventListener('mouseleave', videoContainerEventListener);
    });
    video2.addEventListener("click", () => {
        video1.removeEventListener("ended", playVideo2);
        video2.removeEventListener("ended", playVideo3);
        video3.removeEventListener("ended", playVideo1);
        videoContainer.removeEventListener('mouseleave', videoContainerEventListener);
    });
    video3.addEventListener("click", () => {
        video1.removeEventListener("ended", playVideo2);
        video2.removeEventListener("ended", playVideo3);
        video3.removeEventListener("ended", playVideo1);
        videoContainer.removeEventListener('mouseleave', videoContainerEventListener);
    });
}

PageLoadedQueue.addFunction(shareProfilePage);
PageLoadedQueue.addFunction(videos);
